import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames/bind';
import { Field, Item } from "./..";
import { List } from "../../../../List";
import { ChevronNormalDown } from "../../../../icons";
import { ButtonBase } from "../../../../internal/ButtonBase";
import { ClickOutside } from "../../../../internal/ClickOutside";
import styles from './Select.css';
var cx = classNames.bind(styles);
export var Select = function Select(_ref) {
  var name = _ref.name,
      value = _ref.value,
      options = _ref.options,
      isSearchSelect = _ref.isSearchSelect,
      onChange = _ref.onChange;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      fieldValue = _useState4[0],
      setFieldValue = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      searchValue = _useState6[0],
      setSearchValue = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      foundOptions = _useState8[0],
      setFoundOptions = _useState8[1];

  useEffect(function () {
    if (value && value.label) {
      setFieldValue(value.label);
      setSearchValue(value.label);
    } else {
      setFieldValue(null);
      setSearchValue(null);
    }
  }, [value]);
  useEffect(function () {
    if (foundOptions.length) {
      handleOpen();
    } else {
      handleClose();
    }
  }, [foundOptions]);
  useEffect(function () {
    if (!(searchValue !== null && searchValue !== void 0 && searchValue.length) && searchValue !== null) {
      handleOpen();
    }
  }, [searchValue]);
  var toggleRef = useRef();
  var prepend = /*#__PURE__*/React.createElement("div", {
    className: cx('icon', {
      opened: isOpen
    })
  }, /*#__PURE__*/React.createElement(ChevronNormalDown, {
    color: "N300"
  }));

  var handleToggle = function handleToggle() {
    setIsOpen(function (prevState) {
      return !prevState;
    });
  };

  var handleClose = function handleClose() {
    setIsOpen(false);
  };

  var handleOpen = function handleOpen() {
    setIsOpen(true);
  };

  var searchCurrentOption = function searchCurrentOption(selectValue) {
    return options === null || options === void 0 ? void 0 : options.find(function (optionValue) {
      return selectValue === optionValue.value;
    });
  };

  var handleChooseItem = function handleChooseItem(selectValue) {
    var currentValue = searchCurrentOption(selectValue);

    if (currentValue) {
      onChange(currentValue);
    }

    handleClose();
    setFoundOptions([]);
  };

  var handleChange = function handleChange(fieldData) {
    setFieldValue(fieldData);

    if (fieldData) {
      var currentValue = searchCurrentOption(fieldData);

      if (currentValue) {
        onChange(currentValue);
      }
    } else if (fieldData === null) {
      onChange(null);
    }
  };

  var handleChangeSearchValue = function handleChangeSearchValue(fieldData) {
    setSearchValue(fieldData);

    if (fieldData) {
      setFoundOptions(findSearchValue(fieldData));
      var currentValue = searchCurrentOption(fieldData);

      if (currentValue) {
        onChange(currentValue);
      }
    } else if (fieldData === null) {
      onChange(null);
    } else {
      setFoundOptions([]);
    }
  };

  var findSearchValue = function findSearchValue(data) {
    return options.filter(function (option) {
      var _option$label;

      if (option.label === '') {
        return option;
      }

      return (_option$label = option.label) === null || _option$label === void 0 ? void 0 : _option$label.trim().toLowerCase().includes(data.trim().toLowerCase());
    });
  };

  var optionsForRender = isSearchSelect && foundOptions.length ? foundOptions : options;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('root')
  }, /*#__PURE__*/React.createElement(ButtonBase, {
    ref: toggleRef,
    className: cx('control'),
    onClick: handleToggle
  }, /*#__PURE__*/React.createElement(Field, {
    placeholder: name,
    prepend: prepend,
    value: (isSearchSelect ? searchValue : fieldValue) || '',
    onChange: isSearchSelect ? handleChangeSearchValue : handleChange,
    readOnly: !isSearchSelect
  })), /*#__PURE__*/React.createElement(ClickOutside, {
    className: cx('select', {
      opened: isOpen
    }),
    onClickOutside: handleClose,
    ignoreRefs: [toggleRef]
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('select-body')
  }, /*#__PURE__*/React.createElement(List, null, optionsForRender.map(function (option) {
    return /*#__PURE__*/React.createElement(Item, {
      key: option.value,
      option: option,
      handleChooseItem: handleChooseItem
    });
  })))));
};